import { WHITEBOARD_ID } from '../../../react/features/whiteboard/constants';
import { isWhiteboardVisible } from '../../../react/features/whiteboard/functions';
import {
    isWhiteboardOnMainScreen
} from '../../wizyconf/components/large-video/functions';

function isWildixWhiteboardVisible(state) {
    const { activeParticipants } = state['features/filmstrip'];
    const pinnedParticipantsExceptWhiteboard = activeParticipants
        .filter(p => p.pinned && p.participantId !== WHITEBOARD_ID);
    const isVisible = isWhiteboardVisible(state) && pinnedParticipantsExceptWhiteboard.length === 0;

    return isVisible || isWhiteboardOnMainScreen(state);
}

export {
    isWildixWhiteboardVisible
};
